import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { getMuroProps, isMuroOpen } from '../../../../redux/selectors/editor';
import { closeMuro } from '../../../../redux/actions/editor';
// import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import s from './MicroMuroComment.scss';
const MuroModal = (_param)=>{
    var { editor, onRequestClose } = _param, rest = _object_without_properties(_param, [
        "editor",
        "onRequestClose"
    ]);
    var _editor_storage_daextrenderers, _editor_storage;
    const isOpen = useSelector(isMuroOpen);
    const muroProps = useSelector(getMuroProps);
    const dispatch = useDispatch();
    const handleClose = useCallback(()=>{
        onRequestClose && onRequestClose(null);
        dispatch(closeMuro());
    }, [
        dispatch,
        onRequestClose
    ]);
    /*
  const handleUseDrawing = useCallback(() => {
    editor.commands.daMuroUseDrawing();
    dispatch(closeMuro());
  }, [dispatch, editor.commands]);
  */ if (!(editor === null || editor === void 0 ? void 0 : (_editor_storage = editor.storage) === null || _editor_storage === void 0 ? void 0 : (_editor_storage_daextrenderers = _editor_storage['da-ext-renderers']) === null || _editor_storage_daextrenderers === void 0 ? void 0 : _editor_storage_daextrenderers.muroMini)) {
        return null;
    }
    const MuroMini = editor.storage['da-ext-renderers'].muroMini;
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        className: s['root'],
        heading: 'Create an Image',
        // layoutClassName={s['layout']}
        isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
        showHeaderBorder: true,
        headerRight: /*#__PURE__*/ React.createElement(React.Fragment, null),
        isFullscreen: false,
        onRequestClose: handleClose
    }, rest), isOpen && /*#__PURE__*/ React.createElement(MuroMini, muroProps));
};
MuroModal.displayName = 'MuroModal';
export default MuroModal;

//# sourceMappingURL=MicroMuroComment.js.map